import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useUser } from './hooks';
import { NewbuildingBrokerModalsContext } from '../NewbuildingBrokerModalsProvider';
import { resetOpeningTrigger } from 'shared/actions/newbuildingBrokerCallbackWidget';
import {
  selectCallbackWidgetOfferInfo,
  selectCallbackWidgetOpeningTrigger,
} from 'shared/selectors/newbuildingBrokerCallbackWidget';
import { getNewbuildingBrokerGaLabel } from 'shared/tracking/newbuilding/newbuildingBroker';
import { IOpenBookingCallbackModalParams } from 'shared/types/microfrontends';

export const NewbuildingBrokerCallbackWidgetContainer: React.FC = () => {
  const { startMicrofrontOpening } = React.useContext(NewbuildingBrokerModalsContext);

  const isOpeningTriggered = useSelector(selectCallbackWidgetOpeningTrigger);
  const offerInfo = useSelector(selectCallbackWidgetOfferInfo);
  const user = useUser();

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (isOpeningTriggered) {
      dispatch(resetOpeningTrigger());

      startMicrofrontOpening({
        type: 'bookingCallbackModal',
        params: {
          offerId: offerInfo?.offer.id as number,
          user,
          source: 'listing_label',
          gaLabel: getNewbuildingBrokerGaLabel(offerInfo),
          position: offerInfo?.position,
        } as IOpenBookingCallbackModalParams,
      });
    }
  }, [isOpeningTriggered, offerInfo, user, dispatch, startMicrofrontOpening]);

  return null;
};
